import {
    FormControl,
    Grid2 as Grid,
    InputLabel,
    MenuItem,
    Box,
    Typography,
    Button
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { languages } from '../../../i18n/languages';
import { useRole } from '../../../utils/RoleContext';
import { CommonSelect } from 'component/select';
import { MainCard } from 'component/cards/MainCard2';

const Settings = () => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const { role } = useRole();

    const handleChange = async (e) => {
        await i18n.changeLanguage(e.target.value);
    };
    return (
        <MainCard title={t('profile_settings.general')}>
            <Grid container spacing={8}>
                <Grid size={6}>
                    <Typography variant="h4">
                        {t('profile_settings.language_title')}
                    </Typography>
                    <Box sx={{ height: 16 }} />
                    <FormControl fullWidth>
                        <InputLabel id="language-label">
                            {t('profile_settings.language_label')}
                        </InputLabel>
                        <CommonSelect
                            id="language-label"
                            label={t('profile_settings.language_label')}
                            value={i18n.language}
                            onChange={handleChange}
                        >
                            {Object.entries(languages).map(([code, label]) => (
                                <MenuItem key={code} value={code}>
                                    {label}
                                </MenuItem>
                            ))}
                        </CommonSelect>
                    </FormControl>
                </Grid>
                {role === 'CLINIC_ADMIN' && (
                    <Grid size={6}>
                        <Typography variant="h4">{t('stress.ranges')}</Typography>
                        <Box sx={{ mt: 1 }}>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/stress-test-ranges')}
                            >
                                {t('stress.config')}
                            </Button>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </MainCard>
    );
};

export default Settings;
